import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "user_coupons",
    object: "user_coupon",
    header: [
      { text: "Created At", value: "created_at" },
      { text: "Usuario", value: "user_id", sortable: false },
      { text: "Coupon", value: "coupon_id", sortable: false },
      { text: "Is Used", value: "is_used", sortable: false },
      // { text: "Colores", value: "car_colors"},
      { text: "Acciones", value: "actions", sortable: false },
    ],
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
  },
  getters: {
    ...genericStore.getters,
  },
};
